module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: _vm.theme,
    attrs: {
      "id": "services-page"
    }
  }, [_c('nav-bar'), _vm._v(" "), _c('swiper', {
    ref: "mySwiper3",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticStyle: {
      "height": "100%",
      "background-image": "url('../assets/img/b1.jpg')",
      "background-size": "cover",
      "background-repeat": "no-repeat"
    }
  }, [_c('div', {
    staticClass: "slide-center"
  }, [_c('h1', {
    staticClass: "page__title-white"
  }, [_vm._v(_vm._s(_vm.$t('Customer_Service')))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "page",
    attrs: {
      "id": "quote-form"
    }
  }, [_c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.$t('Customer_Service')))]), _vm._v(" "), _c('hr', {
    staticClass: "page__hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "page__container main"
  }, [_c('div', [_c('p', [_c('strong', [_vm._v("BARNA- TASA S.A.")]), _vm._v(", " + _vm._s(_vm.$t('appraisal_company')) + ", " + _vm._s(_vm.$t('Customer_Service_text_01')) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('Customer_Service')))]), _vm._v(", " + _vm._s(_vm.$t('Customer_Service_text_02')) + ".\n\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_03')) + ":\n\t\t\t\t  ")]), _vm._v(" "), _c('ol', [_c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_04')) + ".\n\t\t\t\t\t\t  ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_05')) + ".\n\t\t\t\t\t\t  ")])])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_06')) + ". " + _vm._s(_vm.$t('Customer_Service_text_09')) + ":\n\t\t\t\t")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.boe.es/diario_boe/txt.php?id=BOE-A-2004-5290",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v(" →\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_12')) + ".")])])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.boe.es/diario_boe/txt.php?id=BOE-A-2011-4117",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v(" →\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_10')) + ".")])])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.boe.es/diario_boe/txt.php?id=BOE-A-2012-14363",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v(" →\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_11')) + ".")])])])])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_13')) + ":\n\n\t\t\t\t  ")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_14')) + ":\n\t\t\t\t\t\t")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('By')) + " " + _vm._s(_vm.$t('e-mail')) + ":\n\t\t\t\t\t  ")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_15')) + ":\n\t\t\t\t\t  ")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_c('u', [_vm._v(_vm._s(_vm.$t('Customer_Service_text_16')) + " "), _c('a', {
    attrs: {
      "href": "http://barnatasa.com/wordpress/wp-content/uploads/2016/07/Hoja_Reclam.pdf",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v(" →" + _vm._s(_vm.$t('link')))])]), _vm._v(". " + _vm._s(_vm.$t('Customer_Service_text_17')) + ":")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_18')) + ".\n\n\t\t\t\t\t\t  ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_19')) + ".\n\n\t\t\t\t\t\t  ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_20')) + ".\n\n\t\t\t\t\t\t  ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_21')) + ".\n\n\t\t\t\t\t\t  ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_22')) + ".\n\n\t\t\t\t\t\t  ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_23')) + ".\n\n\t\t\t\t\t\t  ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_24')) + ".\n\n\t\t\t\t\t\t  ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_25')) + ".\n\n\t\t\t\t\t\t  ")])])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "../assets/pdf/Reg_SAC.pdf",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v(" →\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_07')))])])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "../assets/pdf/Hoja_Reclam.pdf",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v(" → " + _vm._s(_vm.$t('Customer_Service_text_08')))])])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_26')) + ":\n\n\t\t\t\t  ")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("\n\n\t\t\t\t\tDepartamento de Conducta de Mercado y Reclamaciones\n\n\t\t\t\t  ")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tc/ Alcalá, 48\n\n\t\t\t\t  ")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t28014- Madrid\n\n\t\t\t\t  ")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_27')) + ": "), _vm._m(7)])])])]), _vm._v(" "), _c('logo-bar'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("BARNA-TASA S.A.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Servicio de atención al cliente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Còrsega, 168, 1º 1ª")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("08036 - Barcelona")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('p', [_c('strong', [_vm._v("servicio.cliente@barnatasa.com")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('p', [_c('strong', [_vm._v("BARNA-TASA S.A.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Servicio de atención al cliente")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Còrsega, 168, 1º 1ª")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("08036 - Barcelona")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("BANCO DE ESPAÑA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://clientebancario.bde.es",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("Reclamaciones - Oficina Virtual (Banco de España)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5691b2cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CustomerService.vue
// module id = 2149
// module chunks = 0